import ProfileApis from '@/services/apis/profile'

const profile = new ProfileApis()

export default {
  data() {
    return {
      selectedReason: null,
      password: '',
      otpModal: false,
      confirmCode: '',
      verifyCounter: 0,
      resendOtpLoading: false,
      sendOtpLoading: false,
      verifyLoading: false,

    }
  },
  computed: {
    mobile() {
      return this.$store.state.profile.profileInfo.mobile
    },
    reasonOptions() {
      return [
        { text: this.$t('i_have_another_account'), value: 'i_have_another_account' },
        { text: this.$t('privacy_concerns'), value: 'privacy_concerns' },
        { text: this.$t('cant_find_what_i_need'), value: 'cant_find_what_i_need' },
        { text: this.$t('too_distracting'), value: 'too_distracting' },
        { text: this.$t('my_account_was_hacked'), value: 'my_account_was_hacked' },
        { text: this.$t('other_not_specified_here'), value: 'other_not_specified_here' },
      ]
    },
  },
  methods: {
    showModal() {
      if (this.selectedReason) {
        this.sendOtpLoading = true
        this.sendOtp().then(() => {
          this.otpModal = true
        }).catch(error => {
          if (error.status === 428) {
            this.otpModal = true
          }
        })
          .finally(() => {
            this.sendOtpLoading = false
          })
      }
    },
    async sendOtp(isResend) {
      if (isResend) {
        this.resendOtpLoading = true
      }
      return await profile.sendDeleteOtp().then(({ data }) => {
        this.verifyCounter = 60
        this.countDownTimer()
        this.$swal({
          title: data?.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
      }).finally(() => {
        this.resendOtpLoading = false
      })
    },
    countDownTimer() {
      if (this.verifyCounter > 0) {
        setTimeout(() => {
          this.verifyCounter -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    deleteAccount() {
      this.verifyLoading = true
      profile.deleteAccount({ code: this.confirmCode }).then(({ data }) => {
        this.$swal({
          title: data?.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
        localStorage.removeItem('token')
        this.$router.push({ name: 'login' })
      }).finally(() => {
        this.verifyLoading = false
      })
    },
  },
}
